import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../../core/services/auth/auth.service';
import { CommonModule } from '@angular/common';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Router } from '@angular/router';

declare const bootstrap: any;

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loading = false;
  error: string | null = null;
  submitted = false;
  passwordVisible = false;

  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router  
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      rememberMe: [false]
    });
  }

  get f() {
    return this.form.controls;
  }

  togglePasswordVisibility(): void {
    this.passwordVisible = !this.passwordVisible;
  }

  async submit() {
    this.submitted = true;

    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    this.error = null;

    const { email, password } = this.form.value;

    try {
      await this.auth.login(email!, password!);
      this.closeModal();
      this.form.reset();
      this.submitted = false;
      this.router.navigate(['/control-news']); 
    } catch (err: any) {
      this.error = this.mapFirebaseError(err?.code);
    }
    this.loading = false;
  }

  private closeModal(): void {
    const modalElement = document.getElementById('loginModal');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement) ?? new bootstrap.Modal(modalElement);
      modalInstance.hide();
    }
  }

  private mapFirebaseError(code?: string): string {
    switch (code) {
      case 'auth/invalid-email':
        return 'صيغة البريد الإلكتروني غير صحيحة';
      case 'auth/user-disabled':
        return 'تم إيقاف هذا الحساب مؤقتًا';
      case 'auth/user-not-found':
      case 'auth/wrong-password':
        return 'بيانات تسجيل الدخول غير صحيحة';
      default:
        return 'حدث خطأ غير متوقع، حاول مرة أخرى';
    }
  }
}
